import { render } from "./LabeledInputField.vue?vue&type=template&id=a95a36b0"
import script from "./LabeledInputField.vue?vue&type=script&lang=js"
export * from "./LabeledInputField.vue?vue&type=script&lang=js"
script.render = render

export default script